import { useBranding } from "@/context/BrandingContext";
import { useAuth } from "@/context/AuthContext";
import { Zap } from "lucide-react";
import { cn } from "@/lib/utils";

export function Logo({ compact = false, className }) {
  const { logo } = useBranding();
  const { tenant } = useAuth();
  const name = tenant?.branding?.company_display_name || tenant?.name || "primeNetConnect";
  return (
    <div className={cn("flex items-center gap-2.5", className)} data-testid="app-logo">
      {logo ? (
        <img src={logo} alt="Logo" className="h-8 w-8 rounded-md object-contain" />
      ) : (
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent text-accent-foreground">
          <Zap className="h-4 w-4" />
        </div>
      )}
      {!compact && (
        <div className="min-w-0 leading-tight">
          <div className="truncate text-sm font-semibold text-foreground">{name}</div>
          <div className="truncate text-[10px] font-medium uppercase tracking-wider text-muted-foreground">primeNetConnect ERP</div>
        </div>
      )}
    </div>
  );
}
